"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.FontAssetBuilder = exports.FontAsset = void 0;
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var FontAsset = /** @class */ (function () {
    function FontAsset() {
    }
    FontAsset.getFonts = function (fontAssets) {
        return fontAssets.map(function (asset) { return asset.font; });
    };
    return FontAsset;
}());
exports.FontAsset = FontAsset;
var FontAssetBuilder = /** @class */ (function () {
    function FontAssetBuilder(fontAsset) {
        this.fontAsset = fontAsset;
    }
    FontAssetBuilder.initialiseWithFontAsset = function (fontAsset) {
        return new FontAssetBuilder(fontAsset);
    };
    FontAssetBuilder.initialise = function (ownerPartyId, sharedWithEveryone, font) {
        return FontAssetBuilder.initialiseWithFontAsset({
            id: font.id,
            ownerPartyId: ownerPartyId,
            public: sharedWithEveryone,
            font: font,
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    FontAssetBuilder.prototype.build = function () {
        return this.fontAsset;
    };
    FontAssetBuilder.prototype.buildUpdate = function () {
        return {
            ownerPartyId: this.fontAsset.ownerPartyId,
            public: this.fontAsset.public,
            font: this.fontAsset.font
        };
    };
    FontAssetBuilder.prototype.getId = function () {
        return this.fontAsset.id;
    };
    FontAssetBuilder.prototype.withId = function (id) {
        this.fontAsset.id = id;
        this.fontAsset.font.id = id;
        return this;
    };
    FontAssetBuilder.prototype.withFontUpdate = function (fontUpdate) {
        this.fontAsset = {
            id: this.fontAsset.id,
            ownerPartyId: this.fontAsset.ownerPartyId,
            public: this.fontAsset.public,
            font: __assign(__assign({}, this.fontAsset.font), fontUpdate),
            createdAt: this.fontAsset.createdAt,
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        };
        return this;
    };
    return FontAssetBuilder;
}());
exports.FontAssetBuilder = FontAssetBuilder;
